import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let phone = useDataValue({
    viewPath: props.viewPath,
    context: 'phone',
  })
  return useMemo(() => {
    if (!data) return data

    return [
      ...data,
      ...(phone.preference === false
        ? [
            {
              id: 'SET_PREFERRED',
              text: 'Set Preferred',
            },
          ]
        : []),
    ]
  }, [data, phone])
}
